import type { FilterParams } from "epsm-api-types";

export const getFilterParams = (backtestId: string): FilterParams => {
	return [
		{
			name: "backtest_id",
			condition: "eq",
			value: backtestId,
		},
	];
};
